import React from 'react'

const CloseChat = ({color}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
    <g fill="none" fill-rule="evenodd">
        <rect width="50" height="50" fill={`#${color}`} rx="5"/>
        <path fill="#FFF" stroke="#FFF" stroke-width=".5" d="M25.651 27.014l-6.91 6.938a.934.934 0 0 1-1.328 0 .943.943 0 0 1 0-1.33l6.912-6.94-6.912-6.937a.943.943 0 0 1 0-1.331.936.936 0 0 1 1.327 0l6.911 6.937 6.911-6.937a.937.937 0 0 1 1.329 0 .944.944 0 0 1 0 1.33l-6.913 6.939 6.913 6.938a.943.943 0 0 1-.664 1.606.937.937 0 0 1-.664-.275l-6.912-6.938z" opacity=".5"/>
    </g>
  </svg>
)

export default CloseChat



// WEBPACK FOOTER //
// ./src/layouts/CustomMessage/close-chat.js